<ng-container *transloco="let t">
  <tamara-widget
    (click)="logClickEvent()"
    *ngIf="amount"
    type="tamara-summary"
    [attr.amount]="amount"
    [attr.inline-type]="source === 'cart' ? '3' : '2'"></tamara-widget>
</ng-container>
